import React from "react";
import { ServiceTemplateRecurrencePeriod } from "@common/types/serviceTemplateRecurrencePeriod";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import {
    PERIOD_LABELS,
    SUPPORTED_SCHEDULE_PERIODS,
} from "@components/settings/OrganizationCloseTemplates/serviceTemplateSchedule.constants";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const periods = SUPPORTED_SCHEDULE_PERIODS;

const periodsSet: ReadonlySet<string> = new Set(periods);

const options: FilterMultiselectOption[] = periods.map((period) => ({
    value: period,
    label: PERIOD_LABELS[period],
    searchableLabel: PERIOD_LABELS[period],
}));

/** Multi-select filter for the Schedules page — filters by the schedule's recurrence period (daily/weekly/monthly/quarterly/annually). */
export const SchedulePeriodFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.schedulePeriods ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const filtered = val.filter(
                        (v): v is ServiceTemplateRecurrencePeriod =>
                            periodsSet.has(String(v)),
                    );
                    onChange({
                        schedulePeriods:
                            filtered.length > 0 ? filtered : undefined,
                    });
                }}
                name="schedulePeriods"
                onBlur={noop}
            />
        </div>
    );
};
